import { Component, OnInit } from '@angular/core';
import { ListService, SubscriptionService } from '@abp/ng.core';
import { ToasterService, ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Select } from '@ngxs/store';
import { Observable, interval } from 'rxjs';
import { AppModuleManagement } from '../../models';
import { AppModuleManagementState } from '../../states/app-module-management.state';
import { GetAppModule, GetList, UpdateAppModule, CreateAppModule, DeleteAppModule } from '../../actions/app-module-management.actions';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'lib-app-module-management',
	templateUrl: './app-module-management.component.html',
	styleUrls: ['./app-module-management.component.less'],
	providers: [
		ListService
	]
})
export class AppModuleManagementComponent implements OnInit {

	@Select(AppModuleManagementState.appModules)
	appModules$: Observable<AppModuleManagement.AppModuleItem[]>;

	@Select(AppModuleManagementState.appModuleTotalcount)
	appModuleTotalCount$: Observable<number>;

	isModalVisible: boolean = false;

	modalBusy: boolean = false;

	form: FormGroup;

	selected: AppModuleManagement.AppModuleItem;

	constructor(
		public readonly list: ListService,
		private subscription: SubscriptionService,
		private fb: FormBuilder,
		private store: Store,
		private confirmationService: ConfirmationService,
	) { }

	ngOnInit(): void {
		this.hookToQuery();
	}

	private hookToQuery() {

		this.list.hookToQuery(query => {
			return this.store.dispatch(new GetList(query))
		}).subscribe(() => {

		});

	}

	buildForm() {
		this.form = this.fb.group({
			id: [this.selected.id],
			name: [this.selected.name, [Validators.required]],
			code: [this.selected.code, [Validators.required]],
			ico: [this.selected.ico],
			enabled: [this.selected.enabled || true],
			visible: [this.selected.visible || true]
		});
	}

	add() {
		this.selected = {} as AppModuleManagement.AppModuleItem;
		this.showModal();
	}

	showModal() {
		this.buildForm();
		this.isModalVisible = true;
	}

	edit(item: AppModuleManagement.AppModuleItem) {
		this.selected = item;
		this.showModal();
	}

	delete(id: string) {
		this.confirmationService.warn('TerminalManagement::AppModuleDeletionConfirmationMessage', 'AbpIdentity::AreYouSure').subscribe(
			(status: Confirmation.Status) => {
				if (status === Confirmation.Status.confirm) {
					this.store.dispatch(new DeleteAppModule(id))
						.subscribe(() => {
							this.list.get();
						});
				}
			}
		)
	}

	save() {

		let formValues = { ...this.form.value };
		if (!this.selected?.id) {
			delete formValues.id;
		}
		console.log(formValues)
		this.modalBusy = true;
		this.store.dispatch(!!this.selected?.id ? new UpdateAppModule(formValues as AppModuleManagement.UpdateAppModuleRequest) : new CreateAppModule(formValues as AppModuleManagement.CreateAppModuleRequest))
			.pipe(finalize(() => {
				this.modalBusy = false;
				this.isModalVisible = false;
			}))
			.subscribe(() => {
				this.list.get();
			});

	}

	setEnabled(item: AppModuleManagement.AppModuleItem, isEnable: boolean = true) {
		let input = {
			...item
		} as AppModuleManagement.UpdateAppModuleRequest;
		input.enabled = isEnable;
		this.store.dispatch(new UpdateAppModule(input))
			.subscribe(() => this.list.get());
	}

	setVisible(item: AppModuleManagement.AppModuleItem, isVisible: boolean = true) {
		let input = {
			...item
		} as AppModuleManagement.UpdateAppModuleRequest;

		input.visible = isVisible;

		this.store.dispatch(new UpdateAppModule(input))
			.subscribe(() => this.list.get());
	}
}
